var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1639_5990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5203 0.960938H17.0092C17.528 0.960938 18.0271 1.16254 18.3892 1.51774L21.4429 4.51294C21.805 4.86814 22.0105 5.35774 22.0105 5.86654V15.8409C22.0105 16.5033 21.4624 17.0409 20.7871 17.0409H10.5105C9.83519 17.0409 9.28711 16.5033 9.28711 15.8409V2.16094C9.2969 1.49854 9.84498 0.960938 10.5203 0.960938Z",
    stroke: "url(#paint0_linear_1639_5990)",
    strokeOpacity: 0.9,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53766 6.48047H3.18064C1.96703 6.48047 0.978516 7.45007 0.978516 8.64047V20.8805C0.978516 22.0709 1.96703 23.0405 3.18064 23.0405H11.9892C13.2028 23.0405 14.1913 22.0709 14.1913 20.8805V19.5365",
    stroke: "url(#paint1_linear_1639_5990)",
    strokeOpacity: 0.9,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8242 0.960938V5.82814H22.5106",
    stroke: "url(#paint2_linear_1639_5990)",
    strokeOpacity: 0.9,
    strokeWidth: 1.8085
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1639_5990",
    x1: 22.74,
    y1: 0.0103957,
    x2: 17.5583,
    y2: 19.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47297F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#832A89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1639_5990",
    x1: 14.9488,
    y1: 5.50155,
    x2: 9.65075,
    y2: 25.3548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47297F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#832A89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1639_5990",
    x1: 22.8366,
    y1: 0.673221,
    x2: 21.7341,
    y2: 6.72295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47297F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#832A89"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1639_5990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.e9b56d1fa53dbf9b4326f1c278a77157.svg";
export { ForwardRef as ReactComponent };